export enum ENUM_CATEGORY {
  SHOP = 'shop',
  FOOD = 'food'
}

export enum ENUM_SEARCH_TYPE {
  KITCHEN = 'kitchen',
  ADDON = 'addon',
  ADDON_CATEGORY = 'addon_category',
  MEAL_CATEGORY = 'meal_category',
  BRAND = 'brand',
  MEAL = 'meal'
}

export enum ENUM_BRAND_TYPE {
  FOODCOURT = 'foodcourt',
  CHOWDECK = 'chowdeck',
  GLOVO = 'glovo',
  MANO = 'mano',

  FOODCOURT_BUSINESS = 'foodcourt_business',
  FCB_CUSTOM_BREAKFAST = 'fcb_custom_breakfast',
  FCB_CUSTOM_LUNCH = 'fcb_custom_lunch',
  FCB_CUSTOM_AFTERHOURS = 'fcb_custom_afterhours',
  BUDGET = 'budget',
  PIZZA = 'pizza'
}

export enum ENUM_XLS_SHEET_TITLES {
  BASE_MEAL = 'Base Meal',
  BASE_ADDON_CATEGORY = 'Base Addon Category',
  MENU_ITEMS = 'Menu Items',
  ADDON_CATEGORY_MAPPING = 'Addon Category Mapping',
  ADDON_MAPPING = 'Addon Mapping',
  SHOP_ITEMS = 'Shop Items',
  BUDGET_COMBO = 'Budget Combo'
}

export enum ENUM_COKITCHEN_TYPE {
  STANDARD = 'standard',
  POP = 'pop'
}

export enum ENUM_COKITCHEN_STATUS {
  STANDARD = 'standard',
  POPUP = 'popup',
  DINE_IN = 'dine_in'
}

export enum ENUM_TIER_NAME {
  FOODIE = 'Foodie',
  TASTER = 'Taster',
  GOURMET = 'Gourmet',
  FEAST_MASTER = 'Feast Master',
  BON_VIVANT = 'Bon Vivant'
}
export enum ENUM_SHOP_STATUS {
  active = 'active',
  inactive = 'inactive',
  suspended = 'suspended',
  closed = 'closed',
  archived = 'archived'
}

export enum ENUM_JOB_STATUS {
  draft = 'draft',
  open = 'open',
  archived = 'archived'
}
export enum ENUM_MEAL_CATEGORY_LAYOUT {
  HORIZONTAL = 'horizontal',
  VERTICAL = 'vertical'
}
